<script setup lang="ts">
import type { ResolvableScript } from '@unhead/vue'
import { nb_no } from '@nuxt/ui/locale'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

const previewMode = usePreviewMode()

const cart = useCartStore()

function refreshCart() {
  return cart.hydrateTempItems()
}

onMounted(refreshCart)

useEventListener(window, 'focus', refreshCart)

useHead({
  htmlAttrs: {
    lang: 'no',
    prefix: 'og: https://ogp.me/ns#',
    class: 'font-body bg-green-50',
  },
  bodyAttrs: {
    class: 'bg-beige-10',
  },
  script: computed(() => {
    const scripts: ResolvableScript[] = []

    if (previewMode.enabled.value) {
      scripts.push({
        src: 'https://app.crystallize.com/static/frontend-preview-listener.js',
        defer: true,
      })
    }

    return scripts
  }),
})

await useFallbackSeo()
</script>

<template>
  <UApp :locale="nb_no">
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator />
    <LayoutSkipTo />
    <div class="grid min-h-screen grid-rows-[auto_1fr_auto] overflow-x-clip">
      <LayoutHeader />
      <NuxtPage />
      <LayoutFooter />
    </div>
    <VueQueryDevtools />
  </UApp>
</template>
